'use strict';

// 存放result table数据
class ResultWrapper {

    constructor(dataCount = 1) {
        this.data = [];
        for (let i = 0; i < dataCount; i++) {
            this.data.push({});
        }
    }

    filter(value) {
        if (this.data.length > 0 && value instanceof Array) {
            return value[0];
        }
        return value;
    }

    get(key, index = 0) {
        return ResultWrapper.getValueFromObject(this.data[index], key);
    }

    static getValueFromObject(object, key, handleKeyUndefined) {
        let keys = key instanceof Array ? key : key.split(".");
        let value = object;
        for (let index = 0, k; index < keys.length, k = keys[index]; index++) {
            if (!value.hasOwnProperty(k) && handleKeyUndefined && handleKeyUndefined instanceof Function) {
                handleKeyUndefined(value, k, key);
            }
            if (!ResultWrapper.isObject(value[k]) && index < keys.length - 1) {
                return undefined;
            }
            value = value[k];
        }
        return value;
    }

    set(key, value, index = 0) {
        return ResultWrapper.setValueToObject(this.data[index], key, value);
    }

    setAll(key, values) {
        values.forEach((value, index) => this.set(key, value, index));
    }

    static setValueToObject(object, key, value) {
        let keys = key.split(".");
        let k = keys[keys.length - 1];
        let target = object;
        if (keys.length > 1) {
            let pre = keys.slice(0, keys.length - 1);
            target = ResultWrapper.getValueFromObject(object, pre, (object, key) => object[key] = {});
        }
        if (!ResultWrapper.isObject(target)) {
            console.warn(`Set value to object failed - Target is not Object. KEY: ${key}`);
            return false;
        }
        target[k] = value;
        return true;
    }

    getTable() {
        // return table head and rows
        let tableHead = ResultWrapper.parseTableHead(this.data[0]);
        let rows = this.data.map(value => ResultWrapper.parseTableRow(value));
        return {
            tableHead: tableHead,
            tableRows: rows
        }
    }

    static parseTableHead(node, object = {}) {
        let result = [];
        for (let key in node) {
            if (!node.hasOwnProperty(key)) {
                continue;
            }
            let obj = {label: key};
            if (ResultWrapper.isObject(node[key])) {
                obj.children = ResultWrapper.parseTableHead(node[key], object);
            } else {
                let newKey = ResultWrapper.getUnusedKey(key, object);
                object[newKey] = "";
                obj.label = key;
                obj.prop = newKey;
            }
            result.push(obj);
        }
        return result;
    }

    static parseTableRow(node, result = {}) {
        for (let key in node) {
            if (!node.hasOwnProperty(key)) {
                continue;
            }
            if (ResultWrapper.isObject(node[key])) {
                ResultWrapper.parseTableRow(node[key], result);
            } else {
                // 去重
                // fixme: 会有属性不一致问题(如row[0]有'a1', 'a2', 但是row[1]没有'a1', 则row[1].a1实际对应'a2')
                let newKey = ResultWrapper.getUnusedKey(key, result);
                result[newKey] = node[key];
            }
        }
        return result;
    }

    static getUnusedKey(key, object) {
        let i = 2;
        let newKey = key;
        while (object.hasOwnProperty(newKey)) {
            newKey = `${key}${i++}`;
        }
        return newKey;
    }

    static isObject(x) {
        return Object.prototype.toString.call(x) === '[object Object]';
    }

}

module.exports.ResultWrapper = ResultWrapper;



// WEBPACK FOOTER //
// ./src/lib/ucp/result-wrapper.js